export default __webpack_public_path__ + "static/media/Erlik's Ring of the Afterlife.2d229089.jpg";